module.exports = "/shared/img/delete-white.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/delete-white.png
// module id = 13
// module chunks = 13